var _ref2, _ref3;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgClients = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      id: "Group_17012",
      "data-name": "Group 17012",
      width: 23.104,
      height: 26.281,
      viewBox: "0 0 23.104 26.281",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("g", {
      id: "Group_10012",
      "data-name": "Group 10012",
      transform: "translate(4.621)"
    },
    /*#__PURE__*/
    React.createElement("g", {
      id: "Group_10011",
      "data-name": "Group 10011"
    },
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_11440",
      "data-name": "Path 11440",
      d: "M4083.25,88.1a6.5,6.5,0,1,0,6.5,6.5A6.507,6.507,0,0,0,4083.25,88.1Z",
      transform: "translate(-4076.75 -88.104)"
    })))), _ref3 || (_ref3 =
    /*#__PURE__*/
    React.createElement("g", {
      id: "Group_10014",
      "data-name": "Group 10014",
      transform: "translate(0 15.397)"
    },
    /*#__PURE__*/
    React.createElement("g", {
      id: "Group_10013",
      "data-name": "Group 10013"
    },
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_11441",
      "data-name": "Path 11441",
      d: "M4006.944,390.988a9.881,9.881,0,0,0-7.083-2.988h-3.081a9.881,9.881,0,0,0-7.083,2.988,10.1,10.1,0,0,0-2.928,7.122.773.773,0,0,0,.77.774H4009.1a.774.774,0,0,0,.771-.774A10.1,10.1,0,0,0,4006.944,390.988Z",
      transform: "translate(-3986.769 -388)"
    })))))
  );
};

const ForwardRef =
/*#__PURE__*/
React.forwardRef((props, ref) =>
/*#__PURE__*/
React.createElement(SvgClients, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Clients.34f7d1af.svg";
export { ForwardRef as ReactComponent };